import React from 'react';
import {
    Building2,
    CreditCard,
    Wallet,
    User,
    ClipboardList,
    RefreshCcw,
    TrendingUp
} from 'lucide-react';
import './QuickActionsGrid.css';

interface QuickAction {
    id: string;
    label: string;
    icon: React.ElementType;
    color: string;
    route?: string; // sidebar menu id to navigate to
    externalUrl?: string; // external link to open in new tab
}

interface QuickActionsGridProps {
    onNavigate: (route: string) => void;
}

const actions: QuickAction[] = [
    {
        id: 'load-fund',
        label: 'Load Fund',
        icon: Wallet,
        color: '#ff6b35',
        externalUrl: 'https://cards.onafriqpartners.com/Visa/MerchantLite/LoadAuthApprove.aspx'
    },
    { id: 'add-company', label: 'Add Company', icon: Building2, color: '#3b82f6', route: 'companies' },
    { id: 'issue-card', label: 'Issue Card', icon: CreditCard, color: '#10b981', route: 'card-management' },
    { id: 'create-account', label: 'Create Account', icon: User, color: '#8b5cf6', route: 'users' },
    { id: 'transaction', label: 'Transactions', icon: ClipboardList, color: '#f59e0b', route: 'card-activity' },
    { id: 'manage-cards', label: 'Manage Cards', icon: Wallet, color: '#ec4899', route: 'card-management' },
    { id: 'limit-reset', label: 'Invoices', icon: RefreshCcw, color: '#06b6d4', route: 'invoices' },
    { id: 'analytics', label: 'Analytics', icon: TrendingUp, color: '#8b5cf6', route: 'analytics' },
];

const QuickActionsGrid: React.FC<QuickActionsGridProps> = ({ onNavigate }) => {
    return (
        <div className="quick-actions-section">
            <h3 className="section-title-small">Quick Actions</h3>
            <div className="quick-actions-grid">
                {actions.map((action) => {
                    const Icon = action.icon;
                    if (action.externalUrl) {
                        return (
                            <a
                                key={action.id}
                                href={action.externalUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="quick-action-card"
                                style={{ textDecoration: 'none' }}
                                title={`Open ${action.label}`}
                            >
                                <div className="action-icon-circle" style={{ color: action.color, backgroundColor: `${action.color}10` }}>
                                    <Icon size={20} />
                                </div>
                                <span>{action.label}</span>
                            </a>
                        );
                    }

                    return (
                        <button
                            key={action.id}
                            className="quick-action-card"
                            onClick={() => action.route && onNavigate(action.route)}
                            title={`Go to ${action.label}`}
                        >
                            <div className="action-icon-circle" style={{ color: action.color, backgroundColor: `${action.color}10` }}>
                                <Icon size={20} />
                            </div>
                            <span>{action.label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default QuickActionsGrid;
